/**
 * Shared mirrorai Organization schema for structured data.
 * Used as parentOrganization/creator across all products.
 * Machine-facing only — never rendered to users.
 *
 * When a new product joins the fleet, add its URL to sameAs.
 */
export const mirroraiOrganization = {
  '@type': 'Organization' as const,
  name: 'mirrorai',
  url: 'https://narcis.ai', // Primary URL until mirrorai.ai exists
  sameAs: [
    'https://narcis.ai',
    'https://quies.ai',
    'https://ovid.gallery',
  ],
}
